import { GetPersonUser, PersonBenefits } from '@esportal/portal-service';
import { getUserName, getSurname1, getSurname2, getEmail } from '../../../../../helpers/nameHelper';
import { discountHelper } from '../../../../../helpers/discountHelper';
import { HuchaType, HuchaValues, HuchaVentaValues, HuchaPosventaValues } from '../models/hucha-values';
import { getHuchaTierFromDiscounts, getRenovadorDiscountId } from '../../hucha-venta/helpers/get-renovador-tier';
import React from 'react';

const HuchaDiscountIdByType: Record<HuchaType, string> = {
	venta: 'moneybox',
	posventa: 'taller',
};

export const useHuchaValues = (
	userData: GetPersonUser | null,
	personBenefits: PersonBenefits,
	huchaType: HuchaType,
): HuchaValues | null => {
	const { formatNumberWithThousands } = discountHelper();
	const discounts = personBenefits.benefits.discounts ?? [];

	return React.useMemo(() => {
		const getDiscountById = (id: string) => discounts.find((discount) => discount.id === id);

		// datos base
		const baseData = {
			idUser: userData?.portalUser?.data?.clubVW?.idMember || '',
			name: userData ? getUserName(userData) : '',
			apellido1: userData ? getSurname1(userData) : '',
			apellido2: userData ? getSurname2(userData) : '',
			email: userData ? getEmail(userData) : '',
			fechaDescarga: new Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }),
		};

		const huchaDiscount = getDiscountById(HuchaDiscountIdByType[huchaType]);

		if (!huchaDiscount) {
			return null;
		}

		const rawHuchaValue = huchaDiscount?.value.toString() || '0';
		const dineroHucha = formatNumberWithThousands(rawHuchaValue);

		// rama posventa
		if (huchaType === 'posventa') {
			return {
				...baseData,
				huchaType,
				dineroHucha,
			} as HuchaPosventaValues;
		}

		// rama venta
		const huchaTier = getHuchaTierFromDiscounts(discounts);

		// hucha venta estándar
		if (huchaTier === 'standard') {
			return {
				...baseData,
				huchaType,
				huchaTier,
				dineroHucha,
			} as HuchaVentaValues;
		}

		// hucha venta renovadores
		const renovadorDiscountId = getRenovadorDiscountId(huchaTier);

		const renovadoresRaw = getDiscountById(renovadorDiscountId)?.value.toString() || '0';
		const dineroRenovadores = formatNumberWithThousands(renovadoresRaw);

		const huchaNum = parseInt(rawHuchaValue.replace(/\./g, '')) || 0;
		const renoNum = parseFloat(renovadoresRaw) || 0;
		const descuentoTotal = formatNumberWithThousands((huchaNum + renoNum).toString());

		return {
			...baseData,
			huchaType,
			huchaTier,
			dineroHucha,
			dineroRenovadores,
			descuentoTotal,
		} as HuchaVentaValues;
	}, [userData, discounts, huchaType, formatNumberWithThousands]);
};
